import { EntityDefinitionResource } from "../entity-definition-resource";

export interface IEntityDefinitionResourceContainer {
    /**
     * Get a collection of entity definition resources.
     * @returns A collection of {@link EntityDefinitionResource}s.
     */
    getDefinitionResources(): Array<EntityDefinitionResource>;
}
